function updateCartCount(newCount) {
  // Update the cart count in the header
  var cartCountBubble = document.querySelector('.cart-count-bubble span');
  cartCountBubble.innerText = newCount;
  cartCountBubble.setAttribute('aria-hidden', 'true');
  cartCountBubble.nextElementSibling.innerText = newCount;
  //toastr.success('Cart count updated successfully.');
}
function showLoadingSpinner(productId) {
      var loadingOverlay = document.querySelector('#line-price-' + productId + ' .loading-overlay');
    loadingOverlay.classList.remove('hidden');
}
function hideLoadingSpinner(productId) {
      var loadingOverlay = document.querySelector('#line-price-' + productId + ' .loading-overlay');
    loadingOverlay.classList.add('hidden');
}

function updateQuantity(productId, action) {
    var quantityInput = document.getElementById('updates_' + productId);
    var increaseButton = document.getElementById('quantity-plus-' + productId);
    var decreaseButton = document.getElementById('quantity-minus-' + productId);
    var currentQuantity = parseInt(quantityInput.value);
    var form = document.getElementById('product-form-' + productId);
    //var formData = new FormData(form);
    //var addButton = document.getElementById('AddToCart-' + productId);
    var quantitySection = document.getElementById('quantity-section-' + productId);
    var variantIdInput = document.querySelector('input[name="id"]');
    var variantId = variantIdInput.value;



   if (action === 'increase') {
            quantityInput.value = currentQuantity + 1;
        } else if (action === 'decrease') {
            if (currentQuantity > 1) {
                quantityInput.value = currentQuantity - 1;
            } else {
                // Decrease to 0, hide quantity section, enable "Add to Cart" button
                quantityInput.value = 0;
                //decreaseButton.style.display = 'none';
                //increaseButton.style.display = 'none';
                //addButton.style.display = 'block';
                quantityInput.setAttribute('disabled', 'disabled');
                quantitySection.style.display = 'none';
                //addButton.innerText = 'Add to Cart';
                toastr.success('Product has been removed from the cart.');
                // Remove product from the cart
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        quantity: 0,
                        id: variantId
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        // Handle the response if needed
                        console.log('Product removed from cart:', data);
                    })
                    .catch(error => {
                        console.error('Error removing product from cart:', error);
                    });
                  // Update the cart count
                  var cartCount = calculateTotalCartCount();
                  updateCartCount(cartCount);
            }
        }

    // AJAX logic to update the quantity in the cart
    var variantIdInput = form.querySelector('input[name="id"]');
    var variantId = variantIdInput.value;
    showLoadingSpinner(productId); // Show loading spinner while updating

    var updateData = {
        updates: {}
    };
    updateData.updates[variantId] = quantityInput.value;
    toastr.success('Your product has been updated in the cart.');
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
    })
    .then(response => response.json())
    .then(data => {
       hideLoadingSpinner(productId);
        // Handle the response if needed
        console.log('Cart updated successfully', data);
        var linePriceElement = document.getElementById('line-price-' + productId);
        var totalCartElement = document.getElementById('cart-total');
     
            const cart = data.items;
            const totalLinePrice = cart.reduce((total, item) => total + item.line_price, 0);
            var totalCartElement = document.getElementById('cart-total');
            totalCartElement.textContent = '$' + (totalLinePrice / 100).toFixed(2);
            
            cart.forEach(item => {
            var linePriceElement_new = document.getElementById('ct-line-price-' + item.id);
              if (linePriceElement_new) {
              linePriceElement_new.textContent = '$' + (item.line_price / 100).toFixed(2);
              } 
            });

        console.log(totalLinePrice);

    })
    .catch(error => {
        hideLoadingSpinner(); 
        console.error('Error updating cart:', error);
    });
  
    // Update the cart count after updating the cart
    var cartCount = calculateTotalCartCount();
    updateCartCount(cartCount);
}
/*function handleInitialLoadingState() {
    var loadingOverlay = document.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');
    hideLoadingSpinner(); // Call hideLoadingSpinner after 1 second (adjust as needed)
}
window.addEventListener('load', handleInitialLoadingState);*/

function calculateTotalCartCount() {
  // Logic to calculate the total quantity of items in the cart
  var totalCartCount = 0;
  var quantityInputs = document.querySelectorAll('.quantity__input');
  quantityInputs.forEach(function (input) {
    totalCartCount += parseInt(input.value);
  });
  return totalCartCount;
}



